import { AuthorizationService } from 'src/app/services';

export class StatusToolbarHelper {
  public showAction: string;
  public actionText: string;
  public currentToolbar = [];
  private readonly TOOLBAR_ITEMS = [
    { feature: '',
      item: {label: 'Refresh', name: 'refresh', tip: 'Refresh Grid', icon: '#inm-icon__refresh',
      disabled: false, show: true, exclude: true }},
    { feature: 'UI::AuditStatusAdd',
      item: {label: 'Add Status', name: 'addStatus', tip: 'Add New Status',
      icon: '#inm-icon__plus-square', disabled: false, show: true }},
    { feature: 'UI::UpdateAuditStatusWorkflowOrder',
      item: {label: 'Order Status', name: 'orderStatus', tip: 'Apply Workflow Order',
      icon: '#inm-icon__list', disabled: false, show: true }}];
  constructor(private authService: AuthorizationService) {
    this.generateToolbarData();
  }

  generateToolbarData(): void {
    for (let i = 0; i < this.TOOLBAR_ITEMS.length; i++) {
      if (!this.TOOLBAR_ITEMS[i].feature) {
        this.currentToolbar.push(this.TOOLBAR_ITEMS[i].item);
        continue;
      }
      if (this.TOOLBAR_ITEMS[i].feature &&
            this.authService.hasFeature(this.TOOLBAR_ITEMS[i].feature)) {
          this.currentToolbar.push(this.TOOLBAR_ITEMS[i].item);
      }
    }
  }
}
